import Vue from 'vue'
import store from '..'
import firebase from 'firebase/app'
import 'firebase/firestore'

export default {
  namespaced: true,
  state () {
    return {
      groups: [],
      reference: null
    }
  },
  getters: {
    groups (state) {
      return state.groups
    },
    reference (state) {
      return state.reference
    }
  },
  mutations: {
    init (state, payload) {
      state.groups = payload
    },
    add (state, payload) {
      state.groups.push(payload)
    },
    update (state, payload) {
      const index = state.groups.findIndex(group => group.key === payload.key)
      if (index !== -1) {
        Vue.set(state.groups, index, payload)
      }
    },
    remove (state, payload) {
      const index = state.groups.findIndex(group => group.key === payload.key)
      if (index !== -1) {
        state.groups.splice(index, 1)
      }
    },
    reference (state, payload) {
      state.reference = payload
    }
  },
  actions: {
    init ({ commit }) {
      return new Promise((resolve) => {
        commit('init', [])
        resolve()
      })
    },
    subscribe ({ commit }) {
      var boot = true
      var temp = []
      return new Promise((resolve, reject) => {
        commit('init', [])
        const db = firebase.firestore()
        var dbRef = db.collection('groups')
        var reference = dbRef.where('chatsShare', '==', true).onSnapshot(snapshots => {
          if (snapshots.empty) {
            resolve()
          }
          snapshots.docChanges().forEach(change => {
            var data = JSON.parse(JSON.stringify(change.doc.data()))
            if (boot && change.type === 'added') {
              temp.push(data)
            } else if (change.type === 'added') {
              commit('add', data)
            } else if (change.type === 'modified') {
              commit('update', data)
            } else if (change.type === 'removed') {
              commit('remove', data)
            }
          })
          if (boot) {
            boot = false
            commit('init', temp)
          }
          resolve()
        })
        commit('reference', reference)
      })
    },
    unSubscribe ({ commit }) {
      var reference = store.getters['publicGroups/reference']
      return new Promise((resolve) => {
        if (reference) {
          reference()
          commit('reference', null)
          commit('init', [])
          resolve()
        } else {
          resolve()
        }
      })
    }
  }
}
